import ObjectID from "bson-objectid";
import { dt } from "webc-reactcore/src/js/stores/GlobalStore";
import SpindleThreadTypeAPI from "../../../../apicontroller/staircasedata/SpindleThreadTypeAPI";
import React from "react";
import ImagePreview from "../../../../components/ImagePreview";

export function spindleThreadTypesToSelectItems(availableSpindleThreadTypes: SpindleThreadTypeAPI[], allowedSpindleThreadTypes: ObjectID[]) {
    const list = [];
    for (const spindleThreadType of availableSpindleThreadTypes) {
        if(allowedSpindleThreadTypes.findIndex(x => x.toHexString() == spindleThreadType.getId().toHexString()) !== -1){
            list.push(
                {
                    id: spindleThreadType.getSid(),
                    title: dt(spindleThreadType.getTitle()),
                    type: spindleThreadType,
                    preview: <span>{dt(spindleThreadType.getTitle())} <ImagePreview imagePreviewIds={spindleThreadType.getImagePreviewIds()} description={spindleThreadType.getDescription()} ></ImagePreview></span>,
                }
            );
        }
    }
    return list.sort((a, b) => a.title < b.title ? -1 : 1);
}